import React, { Component } from "react";
import {Link} from "react-router-dom";

import './Targets.scss';
import MyContext from '../MyContext.jsx';
import { GiSandsOfTime } from 'react-icons/gi';
import { FaMoneyCheckAlt } from 'react-icons/fa';
import CanvasJSReact from '../../assets/js/canvasjs.react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Select from "react-select";
import BarGraphTarget from "./BarGraphTarget";

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class Targets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category_targets_primaryTargets :[],
      category_targets_secondaryTargets : [],
      executives : [],
      executive : props.executive,
      direct_target: "Y",
      month : props.month??null,
      isSearchDisabled : props.isSearchDisabled ??true,
      needsRefresh: false
    }
    this.getTargetDetails = this.getTargetDetails.bind(this);
    this.executiveChange = this.executiveChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);

  }

  componentDidMount(){    
    this.getTargetDetails();
    // ui.swipeMenu(".home_dashboard_container");
    var obj_this = this;
    const url1 = `${process.env.REACT_APP_SSS}/api/get/executives`;
    this.context.loading(1);
    $.ajax({
      url : url1,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
         executives : return_data.executives,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
    }

    componentDidUpdate(prevProps) {
      if (this.props.month !== prevProps.month || 
        this.props.executive?.value !== prevProps.executive?.value || 
        this.state.needsRefresh) {
      this.setState({ 
        month: this.props.month,
        executive: this.props.executive,
        needsRefresh: false
      }, () => {
        this.getTargetDetails();
      });
    }
    }
    refresh = () => {
      this.setState({ needsRefresh: true });
    }

    getTargetDetails(){

      const url = `${process.env.REACT_APP_SSS}/api/reports/getTargetDetails`;
      var obj_this = this;
      obj_this.context.loading(1);
      $.ajax({
        url : url,
        data : {
          sid : obj_this.context.user_details.sid,
          executive:obj_this.state.executive?.value,
          month : obj_this.state.month!=null?new Date(obj_this.state.month).toLocaleDateString('en-CA'):new Date().toLocaleDateString('en-CA')
        },
        type : "POST"
      }).done(function(return_data){
        console.log(return_data);
        if(return_data.status == "success"){
          obj_this.setState({
            category_targets_primaryTargets : return_data.category_target_primaryTargets,
            pending_percentage_primaryTargets : return_data.category_pending_primaryTargets,
            category_targets_secondaryTargets : return_data.category_target_secondaryTargets,
            pending_percentage_secondaryTargets : return_data.category_pending_secondaryTargets,
            direct_target: return_data.direct_target
          })
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });
    }   
    
    executiveChange(option){
      this.setState({
        executive : option
      });
    }  
    
    formSubmit(e){
      e.preventDefault();
      this.getTargetDetails();
    }

   render(){
    if(this.state.category_targets_primaryTargets.length>3){
      var cal_primary=40 * this.state.category_targets_primaryTargets.length + 20;
      console.log(cal_primary);
    }else{
      var cal_primary=40 * this.state.category_targets_primaryTargets.length + 120;
    }
    if(this.state.category_targets_secondaryTargets.length>3){
      var cal_secondary=40 * this.state.category_targets_secondaryTargets.length + 20;
      console.log(cal_secondary);
    }else{
      var cal_secondary=40 * this.state.category_targets_secondaryTargets.length + 120;
    }
    const primaryoptions = {
       
        axisX: {
          interval: 1,
          // labelAngle: -10 
          labelFontSize: 7,
          reversed:  true,
        },
        responsive: true,
        maintainAspectRatio:false,
        height:cal_primary ,
        toolTip: {
          shared: true
        },
        legend: {
          verticalAlign: "top"
        },
        axisY: {
          suffix: "%",
          labelFontSize: 10,
        },
        data: [{
          type: "stackedBar100",
          color: "#0071ba",
          name: "Achieved",
          showInLegend: true,
          indexLabel: "{y}",
          indexLabelFontColor: "white",
          yValueFormatString: "#,###'%'",
          dataPoints: this.state.category_targets_primaryTargets
        },{
          type: "stackedBar100",
          color: "#FF7F50",
          name: "Pending",
          showInLegend: true,
          indexLabel: "{y}",
          indexLabelFontColor: "white",
          yValueFormatString: "#,###'%'",
          dataPoints: this.state.pending_percentage_primaryTargets
        }]
    }
    const secondaryoptions = {
       
      axisX: {
        interval: 1,
        // labelAngle: -10 
        labelFontSize: 7,
        reversed:  true,
      },
      responsive: true,
      maintainAspectRatio:false,
      height:cal_secondary ,
      toolTip: {
        shared: true
      },
      legend: {
        verticalAlign: "top"
      },
      axisY: {
        suffix: "%",
        labelFontSize: 10,
      },
      data: [{
        type: "stackedBar100",
        color: "#0071ba",
        name: "Achieved",
        showInLegend: true,
        indexLabel: "{y}",
        indexLabelFontColor: "white",
        yValueFormatString: "#,###'%'",
        dataPoints: this.state.category_targets_secondaryTargets
      },{
        type: "stackedBar100",
        color: "#FF7F50",
        name: "Pending",
        showInLegend: true,
        indexLabel: "{y}",
        indexLabelFontColor: "white",
        yValueFormatString: "#,###'%'",
        dataPoints: this.state.pending_percentage_secondaryTargets
      }]
  }
    var category_targets_primaryTargets= this.state.category_targets_primaryTargets;
    var primary_array =category_targets_primaryTargets[0];
    if(primary_array){
      var primary_amount_quantity= primary_array.amount_quantity;
      var primary_category_item= primary_array.category_item;
    }
    var category_targets_secondaryTargets= this.state.category_targets_secondaryTargets;
    var secondary_array = category_targets_secondaryTargets[0];
    if(secondary_array){
      var secondary_amount_quantity= secondary_array.amount_quantity;
      var secondary_category_item= secondary_array.category_item;
    }
    return (
        <MyContext.Consumer>
        {context => (
            <div className="target_container">
                <div className="header_spacer"></div>
                {/* <InfiniteScroll
                        dataLength={ 1 }
                        refreshFunction={this.getTargetDetails}
                        pullDownToRefresh
                        pullDownToRefreshThreshold={200}
                        pullDownToRefreshContent={
                            <h3 style={{ textAlign: 'center' , top : '50px'}}>&#8595; Pull down to refresh</h3>
                        }
                        releaseToRefreshContent={
                            <div className="loading_container" style={{ textAlign: 'center' , top : '100px'}} >
                            <div className="loading_symbol">
                                <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
                                width="40px" height="40px" viewBox="0 0 50 50" style={{enableBackground:'new 0 0 50 50'}}>
                                <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                                </path>
                                </svg>
                            </div>
                            </div>
                        }
                        > */}
                
                <div className="target_dashboard_container uijs swipemenu">
                  <div className="page_header">
                    <div className="page_title">
                      {/* {!this.props.isHome && (
                        <i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i>
                      )} */}
                      Target Details
                    </div>
                  </div> 
                  {
                    this.state.isSearchDisabled ?

                      <div style={{ display: this.state.direct_target == 'N' ? 'block' : 'none' }}>

                        <form className="executive_due_period_form" onSubmit={this.formSubmit}>
                          <div className="blocks">
                            <div className="input_label">Executive</div>

                            <div className="input_grid">
                              <Select
                                options={this.state.executives}
                                value={this.state.executive}
                                className="executive"
                                ref={this.executiveSelect}
                                onChange={e => this.executiveChange(e)}
                                required
                              />
                              <div className="submit_button_container">
                                <button className="submit_button">Submit</button>
                              </div>
                            </div>

                          </div>
                        </form>
                      </div> : undefined
                  }

                    
                </div>
                <div className="list_blocks_container">
                  <div className="input_label">Primary Target</div>
                  <BarGraphTarget  category_targets={this.state.category_targets_primaryTargets} options = {primaryoptions} cal ={cal_primary} amount_quantity={primary_amount_quantity} category_item={primary_category_item}/>

                  <div className="input_label">Secondary Target</div>
                  <BarGraphTarget  category_targets={this.state.category_targets_secondaryTargets} options = {secondaryoptions} cal ={cal_secondary} amount_quantity={secondary_amount_quantity} category_item={secondary_category_item}/>

                </div>
                {/* </InfiniteScroll> */}

                {/** bottom spacer removed; global app_content adds bottom padding **/}

            </div>
        )}
        </MyContext.Consumer>
    )}
}

export default Targets;
Targets.contextType = MyContext;
